module.exports = __webpack_public_path__ + "static/media/19ESCAP43.4dcf9312.jpg";